import angular from 'angular';
import iconComponent from './icon.component';

export default angular.module('cui.graphics.icon', [ ])

.directive('cuiIcon', iconComponent)

.name;
